import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'

interface ProductInfoVariantItemProps {
  isActive?: boolean
  onClick?: () => void
  title: string
  imageUrl: string
  buttonRef?: React.Ref<HTMLButtonElement>
}

export const ProductInfoVariantItem = ({
  isActive,
  onClick,
  imageUrl,
  title,
  buttonRef,
}: ProductInfoVariantItemProps) => {
  return (
    <button
      ref={buttonRef}
      onClick={onClick}
      className={cn(
        'block h-9 cursor-pointer rounded-full border-2 border-neutral-600/30 p-0.5 transition-colors hover:border-primary',
        isActive && 'border-primary'
      )}
    >
      <Image
        src={ImageHelper.getImageUrl(imageUrl, '100_113')}
        alt={`color ${title}`}
        width={50}
        height={30}
        className='h-full w-[50px] rounded-full object-cover'
        unoptimized
      />
    </button>
  )
}
